export class QewlButton {
  enabled!: boolean;
  message!: string;
}
